import { cloneElement, type FC, memo } from 'react';

import { ErrorBoundary } from '@shared/ui/error-boundary';
// import Sidebar from '@widgets/sidebar';
import { Notifications } from '@entities/notifications';

import { Header } from '../../header';
import { LayoutProps } from '../types';

// import withCentrifugeProvider from "helpers/hoc/withCentrifugeProvider";
// import withUserPresenceSubscription from "helpers/hoc/withUserPresenceSubscription";
import styles from './styles.module.scss';

/**
 * Главный каркас приложения: хедер + контент.
 * Каждый крупный блок обёрнут в ErrorBoundary.
 */
const LayoutComponent: FC<LayoutProps> = ({ children, ...rest }) => {
	return (
		<div className={styles.Wrap}>
			<ErrorBoundary>
				<Header />
			</ErrorBoundary>

			{/* <ErrorBoundary> */}
			{/*  <Sidebar {...rest} /> */}
			{/* </ErrorBoundary> */}

			<div className={styles.Main}>
				<ErrorBoundary>
					{/* пробрасываем rest-пропсы в дочерний элемент */}
					{cloneElement(children, rest)}
				</ErrorBoundary>
			</div>

			<ErrorBoundary>
				<Notifications />
			</ErrorBoundary>
		</div>
	);
};

export const Layout = memo(LayoutComponent);

// export default memo(withCentrifugeProvider(withUserPresenceSubscription(Layout), { tokenKey: ''}));
